import { TFunction } from 'react-i18next';
import { ObjectValues } from 'src/common/tsHelpers';

export const MNO_STATUS = {
  UNRECOGNIZED: 0,
  TESTREADY: 1,
  ACTIVEREADY: 2,
  ACTIVE: 3,
  DEACTIVATED: 4,
  TERMINATED: 5,
  INVENTORY: 6,
} as const;

export const MNO_STATUS_FILTER = {
  BLANK: null,
  ...MNO_STATUS,
} as const;

export type MNOStatus = ObjectValues<typeof MNO_STATUS>;

export type MNOStatusFilter = ObjectValues<typeof MNO_STATUS_FILTER>;

export const getLabelBaseOnMnoStatus = (
  subscriptionStatus: MNOStatus,
  t: TFunction<'translation', undefined>,
): string => {
  switch (subscriptionStatus) {
    case MNO_STATUS.ACTIVE: {
      return t('simInventory.mnoStatuses.active');
    }
    case MNO_STATUS.ACTIVEREADY: {
      return t('simInventory.mnoStatuses.activeReady');
    }
    case MNO_STATUS.DEACTIVATED: {
      return t('simInventory.mnoStatuses.deactivated');
    }
    case MNO_STATUS.TERMINATED: {
      return t('simInventory.mnoStatuses.terminated');
    }
    case MNO_STATUS.TESTREADY: {
      return t('simInventory.mnoStatuses.testReady');
    }
    case MNO_STATUS.UNRECOGNIZED: {
      return t('simInventory.mnoStatuses.unrecognized');
    }
    case MNO_STATUS.INVENTORY: {
      return t('simInventory.mnoStatuses.inventory');
    }
    default: {
      return t('common.unknown');
    }
  }
};

export const getFilterLabelBaseOnMnoStatus = (
  mnoStatusFilter: MNOStatusFilter,
  t: TFunction<'translation', undefined>,
) => {
  if (mnoStatusFilter === MNO_STATUS_FILTER.BLANK) {
    return t('common.blank');
  }

  return getLabelBaseOnMnoStatus(mnoStatusFilter, t);
};
